import Axios from 'axios';
import _ from "lodash";
import moment from 'moment';

import { customersActions as A, sortTypes } from './reducer';

import { timers } from '../../config';
import DashboardApi from '../../api/DashboardApi';
import { numberWithCommas, formatDate, getDurationMonthDay } from '../../helpers/formatters';

let inputTimerId = null;

/** Actions */
export const searchCustomers = (options = {resetPage: false}) => async (dispatch, getState) => {
    dispatch(_loading(true));
    if(options.resetPage) {
      dispatch(_setPage(1));
    }
    const customersState = getState().customers;
    const { searchOptions, paginationOptions } = customersState;

    try {
      const result = await DashboardApi.searchCustomers(searchOptions, paginationOptions);
      
      // format customers data
      result.data.users = result.data.users.map(u => {
        // format prices
        u.lifetime_value = numberWithCommas(u.lifetime_value);

        // lifetime date period
        if (u.bookings > 1) {
          u.lifetime_period = getDurationMonthDay(u.first_book_date, u.last_book_date);
        }

        // dates
        u._id.createdAt = formatDate(u._id.createdAt);
        u._id.last_login = formatDate(u._id.last_login) || "Unknown";
        u.last_book_date = formatDate(u.last_book_date) || "Never";

        return u;
      });

      const sortedCustomers = result.data.users; 
      
      // use to sort customers right before they're rendered
      //sort(result.data.users, 'bookings', 'desc', dispatch);
      
      dispatch(_setCustomers(sortedCustomers, result.data.total_pages, result.data.total_users));
    } catch (error) {
      if (Axios.isCancel(error)) {
        console.info('[SEARCH]: Previous request was cancelled!');
      } else {
        console.error(error);
        dispatch(_error("Something went wrong!"));
      }
    }
}

export const sortCustomers = ( sortType ) => (dispatch, getState) => {
  const { sorting, customers } = getState().customers;
  // console.log({sorting, sortType, customers});
  let sorted;
  let sortDir = 'desc';

  if (sorting[sortType] === 'asc' || !sorting[sortType]) {
    dispatch(_setSorting(sortType, 'desc'));
    sortDir = 'desc';
  } else
  if (sorting[sortType] === 'desc') {
    dispatch(_setSorting(sortType, 'asc'));
    sortDir = 'asc';
  }

  // name, bookings
  if (sortType === sortTypes.bookings) {
    sorted = _.orderBy(customers, (o) => _.get(o, sortType, 0), sortDir);
  } else
  // names
  if ([sortTypes.name, sortTypes.email].includes(sortType)) {
    sorted = _.sortBy(customers, (o) => _.get(o, sortType, '').toLowerCase());
    if (sortDir !== 'asc') sorted.reverse();
  } else
  // dates
  if ([sortTypes.createdAt, sortTypes.last_book_date, sortTypes.last_login].includes(sortType)) {
    sorted = _.orderBy(customers, (o) => moment(_.get(o, sortType)), sortDir)
  } else
  // lifetime value
  if (sortType === sortTypes.lifetime_value) {
    sorted = _.orderBy(customers, (o) => Number(_.get(o, sortType, '').replace(/,/,'')), sortDir);
  }

  sorted && dispatch(_setCustomers(sorted));
}


export const setPage = (page) => dispatch => {
  dispatch(_setPage(page));
  dispatch(searchCustomers());
}

export const setPerPage = (per_page) => dispatch => {
  dispatch(_setPerPage(per_page));
  dispatch(searchCustomers({resetPage: true}));
}

export const setVariable = (variable) => dispatch => {
  clearTimeout(inputTimerId);
  dispatch(_setVariable(variable));
  inputTimerId = setTimeout(() => {
    dispatch(searchCustomers({resetPage: true}));
  }, timers.inputTrigger);
};

/** Dispatchers */
function _setCustomers(customers, total_pages, total_customers) {
  const data = { customers };

  if (total_pages) {
    data.total_pages = total_pages;
  }

  if (total_customers) {
    data.total_customers = total_customers;
  }

  return {
    type: A.setCustomers,
    data
  }
}

function _setSorting(type, value) {
  return {
    type: A.setSorting,
    data: { [type]: value }
  }
}

function _setVariable(variable) {
  return {
    type: A.setVariable,
    data: variable
  };
}

function _setPerPage(per_page) {
  return {
    type: A.setPerPage,
    data: per_page
  };
}

function _setPage(page) {
  return {
    type: A.setPage,
    data: page
  };
}

function _loading(status) {
  return {
    type: A.loading_customers,
    data: status
  }
}

function _error(error) {
  return {
    type: A.setError,
    data: error
  }
}